module.exports = __webpack_public_path__ + "static/media/Need Help Icon2.dfdd3ae4.svg";